export const PLAYER_TRAINING_REQUEST = "PLAYER_TRAINING_REQUEST";
export const PLAYER_TRAINING_SUCCESS = "PLAYER_TRAINING_SUCCESS";
export const PLAYER_TRAINING_ERROR = "PLAYER_TRAINING_ERROR";

export const PLAYER_TRAINING_REG = "PLAYER_TRAINING_REG";
